export const AVATAR_COLORS = [
  'linear-gradient(135deg, #6D5DFB 0%, #A855F7 100%)',
  'linear-gradient(135deg, #0891B2 0%, #2DD4BF 100%)',
  'linear-gradient(135deg, #E5484D 0%, #F59E62 100%)',
  'linear-gradient(135deg, #DB2777 0%, #FB7185 100%)',
  'linear-gradient(135deg, #047857 0%, #34D399 100%)',
  'linear-gradient(135deg, #B45309 0%, #FBBF24 100%)',
];
